(() => {
  'use strict';
  // Locale strings from layout/theme.liquid (window.abrReviewsStrings); English when missing.
  const abrText = (key, english, values) => {
    const strings = window.abrReviewsStrings || {};
    let text = typeof strings[key] === 'string' && strings[key] ? strings[key] : english;
    if (values) Object.keys(values).forEach((name) => { text = text.split(`[${name}]`).join(String(values[name])); });
    return text;
  };

  if (window.__adobeReviewsMedia) return;
  window.__adobeReviewsMedia = true;

  let dialog;
  let image;
  let previous;
  let next;
  let items = [];
  let index = 0;
  let returnFocus;

  function build() {
    if (dialog) return;

    dialog = document.createElement('dialog');
    dialog.className = 'abr-lightbox';
    dialog.innerHTML = '<div class="abr-lightbox__stage"><button class="abr-lightbox__close" type="button" aria-label="Close">×</button><button class="abr-lightbox__previous" type="button" aria-label="Previous image">‹</button><figure class="abr-lightbox__figure"><img class="abr-lightbox__image" alt=""></figure><button class="abr-lightbox__next" type="button" aria-label="Next image">›</button><p class="abr-lightbox__count" aria-live="polite"></p></div>';
    document.body.append(dialog);

    image = dialog.querySelector('.abr-lightbox__image');
    previous = dialog.querySelector('.abr-lightbox__previous');
    next = dialog.querySelector('.abr-lightbox__next');

    dialog.querySelector('.abr-lightbox__close').addEventListener('click', close);
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });

    dialog.addEventListener('close', () => {
      returnFocus?.focus({ preventScroll: true });
      returnFocus = null;
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
  }

  function show(nextIndex) {
    if (!items.length) return;

    index = (nextIndex + items.length) % items.length;
    const item = items[index];
    image.src = item.src;
    image.alt = item.alt;
    previous.hidden = items.length < 2;
    next.hidden = items.length < 2;
    // Which picture of how many, like a clip counter: "01 / 02".
    const count = dialog.querySelector('.abr-lightbox__count');
    const pad = (n) => String(n).padStart(2, '0');
    count.hidden = items.length < 2;
    count.textContent = `${pad(index + 1)} / ${pad(items.length)}`;
  }

  function open(link) {
    build();

    const review = link.closest('.jdgm-rev');
    items = Array.from(review?.querySelectorAll('.jdgm-rev__pic-link') || [])
      .map((candidate) => {
        const candidateImage = candidate.querySelector('img');
        return {
          link: candidate,
          src: candidate.href || candidateImage?.currentSrc || candidateImage?.src,
          alt: candidateImage?.alt || ''
        };
      })
      .filter((item) => item.src);

    index = Math.max(0, items.findIndex((item) => item.link === link));
    returnFocus = link;
    show(index);
    dialog.showModal();
  }

  function close() {
    if (dialog?.open) dialog.close();
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.template-product .jdgm-review-widget .jdgm-rev__pic-link');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    open(link);
  }, true);
})();

/*
 * The widget's Premiere look (styles: adobe-reviews-alignment-fix-v2.css).
 * Purely presentational, on top of the widget script (adobe-reviews-ui):
 *
 *   - a panel tab bar across the top ("Project: Reviews", a bin icon, the
 *     review count in mono) and a ruler plus playhead over the rating
 *     histogram, which reads as a timeline of tracks;
 *   - the parts of the widget become scroll scenes (motion-scenes.js arms
 *     [data-scene] and sets data-played in view; the CSS plays entrances
 *     off that, with backwards fill only, so nothing is ever held hidden);
 *   - the rating and the tab's review count count up from zero as their
 *     scenes play. The running value is painted from an attribute (the
 *     numbers' own text never changes); without motion they simply show
 *     the real value.
 *
 * It never adds or moves nodes inside the review list, never writes style
 * attributes in the widget and does no work while the page is idle: the
 * widget script treats inserted nodes as "the next page arrived" and style
 * writes as a widget change.
 */
(() => {
  'use strict';
  // Locale strings from layout/theme.liquid (window.abrReviewsStrings); English when missing.
  const abrText = (key, english, values) => {
    const strings = window.abrReviewsStrings || {};
    let text = typeof strings[key] === 'string' && strings[key] ? strings[key] : english;
    if (values) Object.keys(values).forEach((name) => { text = text.split(`[${name}]`).join(String(values[name])); });
    return text;
  };

  if (window.__adobeReviewsLook) return;
  window.__adobeReviewsLook = true;

  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const BIN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" focusable="false"><path d="M3 6.5A1.5 1.5 0 0 1 4.5 5h4.2l2 2.2h8.8A1.5 1.5 0 0 1 21 8.7v9.8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18.5z"/></svg>';
  const counted = new WeakSet();
  let frame = 0;
  let observer = null;
  let watched = null;

  const widget = () => document.querySelector('.template-product .jdgm-review-widget');

  function element(tag, className, html) {
    const node = document.createElement(tag);
    node.className = className;
    node.setAttribute('aria-hidden', 'true');
    if (html) node.innerHTML = html;
    return node;
  }

  function chrome(root) {
    const total = Number.parseInt(root.dataset.numberOfReviews, 10) || 0;
    const label = total === 1
      ? abrText('items_one', '[count] item', { count: String(total).padStart(2, '0') })
      : abrText('items_other', '[count] items', { count: String(total).padStart(2, '0') });
    let bar = root.querySelector(':scope > .abr-chrome');
    if (!bar) {
      bar = element('div', 'abr-chrome',
        `<span class="abr-chrome__tab">${BIN}<span class="abr-chrome__name">${abrText('project', 'Project:')}</span><span class="abr-chrome__title">${abrText('panel_title', 'Reviews')}</span></span>` +
        '<span class="abr-chrome__count"></span><span class="abr-chrome__dots"><i></i><i></i><i></i></span>');
      root.prepend(bar);
    }
    const count = bar.querySelector('.abr-chrome__count');
    if (count.textContent !== label) count.textContent = label;
    return bar;
  }

  function timeline(histogram) {
    if (!histogram.querySelector(':scope > .abr-ruler')) {
      histogram.prepend(element('div', 'abr-ruler',
        `<span class="abr-ruler__label">${abrText('ratings', 'Ratings')}</span><span class="abr-ruler__scale"><i>0%</i><i>25%</i><i>50%</i><i>75%</i><i>100%</i></span>`));
    }
    if (!histogram.querySelector(':scope > .abr-playhead')) {
      histogram.append(element('div', 'abr-playhead', '<i></i>'));
    }
  }

  // Painted counters: the score and the tab's review count run up from
  // zero while their scene plays (eased out, like the timecodes elsewhere
  // on the site), then hand back to their own text. The running value is
  // an attribute the CSS paints over the (transparent) real text - the
  // text itself never changes, since the widget script reads text changes
  // in the widget as "the next page arrived".
  const scoreText = (score) => String(score.dataset.value || score.textContent).trim();

  function run(node, target, format, duration, delay) {
    if (still.matches || !Number.isFinite(target)) {
      node.removeAttribute('data-abr-count');
      return;
    }
    let start = 0;
    const step = (now) => {
      if (!start) start = now + delay;
      const t = Math.min(1, Math.max(0, (now - start) / duration));
      if (t >= 1 || !node.isConnected) {
        node.removeAttribute('data-abr-count');
        return;
      }
      const value = format(target * (1 - Math.pow(1 - t, 3)));
      if (node.getAttribute('data-abr-count') !== value) node.setAttribute('data-abr-count', value);
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  // Armed (it will play once in view), the counter waits at zero, so it
  // never shows its value first and then drops back to count. It runs with
  // its scene's entrance. Should the scene not play although it is in view
  // (by motion-scenes.js's own measure: 15% of it above the bottom 6%) for
  // a moment, the counter runs anyway, so it is never left sitting at zero.
  // Both watchers go as soon as it runs.
  function armCounter(scene, node, target, format, duration, delay) {
    if (!node || counted.has(node)) return;
    if (!scene.hasAttribute('data-armed') || scene.hasAttribute('data-played')) return;
    counted.add(node);
    node.setAttribute('data-abr-count', format(0));
    let started = false;
    let wait = 0;
    let seen = null;
    const go = (lag) => {
      if (started) return;
      started = true;
      window.clearTimeout(wait);
      played.disconnect();
      seen?.disconnect();
      run(node, target, format, duration, lag);
    };
    const played = new MutationObserver(() => {
      if (scene.hasAttribute('data-played')) go(delay);
    });
    played.observe(scene, { attributes: true, attributeFilter: ['data-played'] });
    seen = new IntersectionObserver((entries) => {
      window.clearTimeout(wait);
      if (!entries[entries.length - 1].isIntersecting) return;
      wait = window.setTimeout(() => go(0), 360);
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    seen.observe(scene);
  }

  function armScore(summary) {
    const score = summary.querySelector('.abr-score');
    if (!score) return;
    const text = scoreText(score);
    const places = (text.split('.')[1] || '').length;
    armCounter(summary, score, Number.parseFloat(text), (value) => value.toFixed(places), 1200, 180);
  }

  // "116 items" runs up in the tab as it draws in, in the same digits as
  // its final text (so the painted value sits exactly over it).
  function armTabCount(bar, root) {
    const total = Number.parseInt(root.dataset.numberOfReviews, 10) || 0;
    const digits = Math.max(2, String(total).length);
    const unit = total === 1 ? 'item' : 'items';
    armCounter(bar, bar.querySelector('.abr-chrome__count'), total,
      (value) => `${String(Math.round(value)).padStart(digits, '0')} ${unit}`, 900, 260);
  }

  // The list's header row: Judge.me's sort wrapper or, in markup without
  // one, its dropdown wrapper (the pill sits in whichever holds the select).
  function sortRow(root) {
    return root.querySelector('.jdgm-rev-widg__sort-wrapper') ||
      root.querySelector('.jdgm-sort-dropdown-wrapper');
  }

  function decorate() {
    frame = 0;
    const host = widget();
    const root = host?.querySelector('.jdgm-rev-widg.abr-reviews');
    if (!root) return;
    watch(host);

    const bar = chrome(root);
    const scenes = [bar];
    const histogram = root.querySelector('.abr-distribution');
    if (histogram) {
      timeline(histogram);
      scenes.push(histogram);
    }
    const summary = root.querySelector('.abr-summary');
    if (summary) scenes.push(summary);
    const sort = sortRow(root);
    if (sort) scenes.push(sort);
    const body = root.querySelector('.jdgm-rev-widg__body');
    if (body) scenes.push(body);
    scenes.forEach((scene) => {
      if (!scene.hasAttribute('data-scene')) scene.setAttribute('data-scene', '');
    });
    window.motionScenes?.arm(host);
    armTabCount(bar, root);
    if (summary) armScore(summary);
  }

  function queue() {
    if (!frame) frame = requestAnimationFrame(decorate);
  }

  // The widget script builds the layout this dresses (and Judge.me can
  // re-render it): only a missing piece brings this back, so the observer
  // callback is a few selector checks and otherwise does nothing.
  function watch(host) {
    if (watched === host) return;
    observer?.disconnect();
    watched = host;
    observer = new MutationObserver(() => {
      const root = host.querySelector('.jdgm-rev-widg.abr-reviews');
      if (!root) return;
      const histogram = root.querySelector('.abr-distribution');
      const sort = sortRow(root);
      if (
        !root.querySelector(':scope > .abr-chrome') ||
        (histogram && (!histogram.hasAttribute('data-scene') || !histogram.querySelector(':scope > .abr-playhead'))) ||
        (sort && !sort.hasAttribute('data-scene')) ||
        root.querySelector('.abr-summary:not([data-scene]), .jdgm-rev-widg__body:not([data-scene])')
      ) queue();
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  // After DOMContentLoaded: every deferred script has run by then, so the
  // widget script has had its first go and motion-scenes.js is there to
  // arm the scenes. A few more passes catch a widget Judge.me renders late.
  let started = false;
  function start() {
    if (started) return;
    started = true;
    queue();
    [120, 400, 1000, 2500].forEach((delay) => window.setTimeout(queue, delay));
    document.addEventListener('shopify:section:load', queue);
    // A widget Judge.me only renders later: watch the page until it is
    // there (then the widget's own observer above takes over).
    if (!watched) {
      const arrival = new MutationObserver(() => {
        if (watched) arrival.disconnect();
        else if (document.querySelector('.template-product .jdgm-review-widget .jdgm-rev-widg')) queue();
      });
      arrival.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'complete') start();
  else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    window.addEventListener('load', start, { once: true });
  }
})();
